/**
 * Pushes a custom event to GTM
 *
 * Example Object : { 'event' : 'item_assigned_to_feed', 'itemCount' : 5 }
 * Example Object : { 'event' : 'item_created' }
 *
 * @param {Object} event_data
 */
export function gtmEventPush(event_data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event_data);
}
